import { type CustomizationMachineAction } from '../../types';
import { customizationLogger } from './logger';

// ─────────────────────────────────────────────────────────────────────────────

export function createPlaceholderAction(
  actionName: string,
): CustomizationMachineAction {
  return () => {
    customizationLogger.info(`\`${actionName}\` action is not provided.`);
  };
}

export function createPlaceholderGuard(guardName: string) {
  return () => {
    customizationLogger.info(`\`${guardName}\` guard is not provided.`);

    return false;
  };
}
